module.exports = __webpack_public_path__ + "static/media/logServosActive.47fecdc6.svg";